require('es6-promise').polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'

import Axios from 'axios'

import vuexI18n from 'vuex-i18n'
import i18n from './services/i18n'

import BootstrapVue from 'bootstrap-vue'

import miniToastr from 'mini-toastr'
import VueHighlightJS from 'vue-highlightjs'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/fonts.css'
import './assets/css/foobar.beer.css'
import './assets/css/admin.css'
import './assets/css/auth.css'
import './assets/css/content.css'
import './assets/css/home.css'
import './assets/css/parallax.css'
import 'highlight.js/styles/darcula.css'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Axios)
Vue.use(VueHighlightJS)

import store from './services/store'

Vue.use(vuexI18n.plugin, store)

router.beforeEach((to, from, next) => {
  if ((to.matched.some(record => record.meta.requiresAdmin) && !store.state.auth.admin) ||
    (to.matched.some(record => record.meta.requiresEditor) && !store.state.auth.editor)) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

Vue.i18n.add('cs', i18n.cs)
Vue.i18n.add('en', i18n.en)

Vue.i18n.set('en')

miniToastr.init()

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js